import Vue from 'vue'
import App from './App.vue'
import store from '@plugins/vuex'
// import router from '@plugins/router'
Vue.config.productionTip = false

import Group from '@components/Group.vue'
import Typeahead from '@components/Typeahead.vue'
import PageArea from '@pages/Area.vue'

Vue.component('Group', Group)
Vue.component('Typeahead', Typeahead)
Vue.component('PageArea', PageArea)

new Vue({
  render: h => h(App),
  store
}).$mount('#modulekonfigurator')
